import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-carousel-promotional-profile',
  templateUrl: './carousel-promotional-profile.component.html',
  styleUrls: ['./carousel-promotional-profile.component.scss']
})
export class CarouselPromotionalProfileComponent implements OnInit {

  @Input() diviceXs: boolean;
  @Input() diviceSm: boolean;

  slidesList = [
    { url: './assets/img/banner01.jpg' },
    { url: './assets/img/banner02.jpg' },
    { url: './assets/img/banner03.jpg' }
  ];

  slidesListCell = [
    { url: './assets/img/banner01Cell.jpg' },
    { url: './assets/img/banner02Cell.jpg' },
    { url: './assets/img/banner03cell.jpg' }
  ];
  
  constructor() { }

  ngOnInit(): void {
    console.log("diviceXs",this.diviceXs);
  }

}
